module.exports = __webpack_public_path__ + "static/fipcsafari3-dce0160f8065326734fe435543ef108e.jpeg";